module.exports = __webpack_public_path__ + "img/keyboard_Backspace.80c26c44.png";